import {
  TICKETING_LOGOS,
  TICKETING_OUTLINED_LOGOS
} from "./TicketingSystemLogo.constants"

import type { TicketingSystemLogoProps } from "./TicketingSystemLogo.types"

export const TicketingSystemLogo = (props: TicketingSystemLogoProps) => {
  const { system, outlined, className } = props
  const Logo = (outlined ? TICKETING_OUTLINED_LOGOS : TICKETING_LOGOS)[system]

  return <Logo className={className} />
}
